import styled from 'styled-components';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/trucks_job/trucks_contract_row_shadow.png';

const StyledContainer = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: 60px 2px 178px 2px 226px 2px 1fr 40px;
	align-items: center;
	gap: 20px;
	padding: 0 20px;
	height: 100px;
	min-height: 100px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	overflow: hidden;

	& > img {
		width: 60px;
		height: 60px;
		border-radius: 5px;
		user-select: none;
		pointer-events: none;
	}

	.dividers {
		display: flex;

		${Divider} {
			height: 60px;
		}
	}
`;

const StyledInfoContainer = styled.div`
	height: 100%;
	padding-top: 17px;
	color: #ffffff;
`;

const StyledTagsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-top: 9px;
`;

const StyledTag = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 20px;
	padding: 0 5px;
	border-radius: 5px;
	background-color: rgba(255, 255, 255, 0.05);

	${Text} {
		font-weight: 500;
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledPriceXPContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-top: 9px;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledPriceContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
`;

const StyledShadow = styled.div`
	position: absolute;
	top: 50%;
	right: -250px;
	transform: translateY(-50%);
	width: 500px;
	height: 500px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

export {
	StyledContainer,
	StyledInfoContainer,
	StyledPriceContainer,
	StyledPriceXPContainer,
	StyledShadow,
	StyledTag,
	StyledTagsContainer,
};
